var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { ClassThemeProvider } from '@class-ui/theme/dist/ClassThemeProvider';
import { Tabs, Tab, Typography, Popover, Box, styled, Button, Tooltip } from '@mui/material';
import { grey } from '@mui/material/colors';
const StyledPopover = styled(Popover) `
    & .MuiPaper-root {
        padding: 0 12px 12px 12px;
    }
`;
const RowContainer = styled(Box) `
    display: flex;
    min-height: 56px;
    justify-content: space-between;
    column-gap: 12px;
    margin-top: 8px;
`;
const StyledBottomContainer = styled(RowContainer) `
    min-height: 36px;
    justify-content: center;
`;
const shouldForwardProp = (prop) => !['active', 'isInstructor'].includes(prop);
const ReactionButton = styled(Button, {
    shouldForwardProp
}) `
    padding: 4px;
    border-radius: 12px;
    background-color: ${(props) => {
    if (props.active) {
        return props.isInstructor ? props.theme.palette.primary.dark : grey[800];
    }
    return props.isInstructor ? props.theme.palette.other.brandColor : 'inherit';
}};

    &:hover {
        background-color: ${(props) => (props.isInstructor ? props.theme.palette.primary.dark : grey[800])};
    }
`;
const TooltipButton = styled(ReactionButton) `
    & .MuiSvgIcon-root {
        font-size: 28px;
        width: 28px;
        height: 28px;
    }
`;
const SubtitleButton = styled(ReactionButton) `
    flex-flow: column;
    flex-basis: 0;
    flex-grow: 1;
    padding-bottom: 2px;
`;
const StyledLabel = styled(Typography) `
    max-width: 84px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
const ClearReactionButton = styled(Button) `
    border-radius: 4px;
    padding: 6px 16px;

    &:hover {
        background-color: ${grey[800]};
    }
`;
const SubtitleIconWrapper = styled(Box) `
    margin-bottom: 0px;
    & .MuiSvgIcon-root {
        font-size: 26px;
        width: 26px;
        height: 26px;
    }
`;
const StyledTab = styled(Tab) `
    flex: 1;
    text-transform: none;
`;
export const ReactionsPopover = (props) => {
    const { activeReaction, tooltipItems, subtitleItems, onClearClick, onReactionClick, texts } = props, rest = __rest(props, ["activeReaction", "tooltipItems", "subtitleItems", "onClearClick", "onReactionClick", "texts"]);
    const { name: activeReactionName, mode: activeReactionMode } = activeReaction || {};
    const [currentTab, setCurrentTab] = useState('share-everyone');
    const handleTabChange = (event, newValue) => {
        setCurrentTab(newValue);
    };
    const handleClearReaction = () => {
        onClearClick();
    };
    const handleReactionClick = (reaction) => {
        onReactionClick(reaction.name, currentTab);
    };
    const isInstructorTab = currentTab === 'share-instructors';
    const isActive = (reactionName) => activeReactionName === reactionName && activeReactionMode === currentTab;
    const getReactionButton = (reaction, type) => {
        if (type === 'subtitle') {
            return (_jsxs(SubtitleButton, { isInstructor: isInstructorTab, onClick: () => handleReactionClick(reaction), active: isActive(reaction.name), children: [_jsx(SubtitleIconWrapper, { children: reaction.icon }), _jsx(StyledLabel, { variant: 'body2', children: reaction.label })] }, reaction.name));
        }
        return (_jsx(Tooltip, { title: reaction.label, children: _jsx(TooltipButton, { isInstructor: isInstructorTab, onClick: () => handleReactionClick(reaction), active: isActive(reaction.name), children: reaction.icon }) }, reaction.name));
    };
    return (_jsx(ClassThemeProvider, { theme: 'dark', cssReset: 'scoped', children: _jsxs(StyledPopover, Object.assign({}, rest, { children: [_jsxs(Tabs, { value: currentTab, onChange: handleTabChange, children: [_jsx(StyledTab, { value: 'share-everyone', label: texts.shareWithEveryone }), _jsx(StyledTab, { value: 'share-instructors', label: texts.shareWithInstructors })] }), tooltipItems && (_jsx(RowContainer, { children: tooltipItems.map((item) => getReactionButton(item, 'tooltip')) })), subtitleItems && (_jsx(RowContainer, { children: subtitleItems.map((item) => getReactionButton(item, 'subtitle')) })), activeReaction && (_jsx(StyledBottomContainer, { children: _jsx(ClearReactionButton, { onClick: handleClearReaction, children: _jsx(Typography, { variant: 'body2', children: texts.clearReaction }) }) }))] })) }));
};
